import React, { FunctionComponent } from 'react';
import { Button, ButtonGroup, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { StyledEditablePropertyItemContainer } from './commandItemStyles';
import Strings from '../../i18n';

type ValueType = number | boolean;

type CommandItemProps = {
  nameCommand: string;
  loading: boolean;
  onSave: (value: any) => void;
  haveGroupButton?: boolean;
  value: ValueType;
  onChange: (value: ValueType) => void;
};

export const CommandItem: FunctionComponent<CommandItemProps> = ({
  nameCommand,
  loading,
  onSave,
  haveGroupButton,
  value,
  onChange
}) => {
  const isBoolean = !!haveGroupButton;

  return (
    <StyledEditablePropertyItemContainer>
      <Typography sx={{ flex: 1 }} textAlign="center">
        {nameCommand}
      </Typography>

      {isBoolean ? (
        <ButtonGroup sx={{ flex: 1 }} size="small">
          <Button
            onClick={() => onChange(false)}
            color="primary"
            variant={!value ? 'contained' : 'outlined'}
            sx={
              value
                ? {
                    color: 'grey.700',
                    borderColor: 'grey.500',
                    '&:hover': {
                      borderColor: 'grey.700',
                      backgroundColor: 'action.hover'
                    }
                  }
                : undefined
            }
          >
            Disable
          </Button>

          <Button
            onClick={() => onChange(true)}
            color="primary"
            variant={value ? 'contained' : 'outlined'}
            sx={
              !value
                ? {
                    color: 'grey.700',
                    borderColor: 'grey.500',
                    '&:hover': {
                      borderColor: 'grey.700',
                      backgroundColor: 'action.hover'
                    }
                  }
                : undefined
            }
          >
            Enable
          </Button>
        </ButtonGroup>
      ) : (
        <TextField
          size="small"
          sx={{ flex: 2 }}
          value={String(value ?? '')}
          onChange={(e) => {
            const v = e.target.value;

            onChange(v === '' ? ('' as unknown as number) : parseInt(v, 10));
          }}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        />
      )}

      <LoadingButton
        variant="contained"
        sx={{ flex: 1, height: '40px' }}
        loading={loading}
        onClick={() => onSave(value)}
      >
        {Strings.common.send}
      </LoadingButton>
    </StyledEditablePropertyItemContainer>
  );
};
